import { styled } from "@mui/material/styles";
import { Box } from "@mui/material";

interface AuthPageContentProps {
  withHeaderImage: boolean;
  contentWidth?: string | number;
}

export const AuthPageContainer = styled(Box)(({ theme }) => ({
  minHeight: "100vh",
  backgroundColor: theme.palette.background.default,
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  paddingTop: "60px",
  paddingLeft: "60px",
  paddingRight: "60px",
  paddingBottom: "60px",
  [theme.breakpoints.down("sm")]: {
    paddingTop: "24px",
    paddingLeft: "20px",
    paddingRight: "20px",
    paddingBottom: "24px",
  },
}));

export const AuthPageContent = styled(Box, {
  shouldForwardProp: (prop) =>
    prop !== "withHeaderImage" && prop !== "contentWidth",
})<AuthPageContentProps>(({ theme, withHeaderImage, contentWidth }) => ({
  width: contentWidth || "100%",
  maxWidth: contentWidth || "640px",
  backgroundColor: theme.palette.background.paper,
  borderRadius: "24px",
  boxShadow: theme.palette.shadow.modal,
  marginTop: "60px",
  padding: withHeaderImage ? "60px 120px 90px 120px" : "90px 120px",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  [theme.breakpoints.down("sm")]: {
    borderRadius: "12px",
    marginTop: "40px",
    padding: withHeaderImage ? "40px 24px 48px 24px" : "48px 24px",
    width: "100%",
    maxWidth: "100%",
  },
}));
